export interface ProductionProcess {
  id: string;
  description: string;
  productionProcessType: string;
}
